import {
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { SearchResultsRowComponent } from '@adw/projects/aca-content/src/lib/components/search/search-results-row/search-results-row.component';

@Component({
  selector: 'wk-search-results-row',
  templateUrl: './wk-search-results-row.component.html',
  styleUrls: ['./wk-search-results-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'aca-search-results-row' },
  standalone: false,
})
export class WkSearchResultsRowComponent extends SearchResultsRowComponent {}
